// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aDYe","col":"styles_col__2Ey9Z"};